import * as Sentry from '@sentry/react';
import {FileCrmImport} from '../../shared/api/definitions/import';
import {useApiMutation} from '../../hooks/api/api';

export const useQueueFileCrmImport = () => {
  return useApiMutation(FileCrmImport, {
    onError: (error) => {
      Sentry.captureException(error);
    },
  });
};
